<template>
  <div class="dispute-case-tags">
    <div
      v-for="(item, index) in tagData"
      :key="`${item.key}-${index}`"
      class="dispute-case-tags-item"
      :class="
        item.key === 'Case Aging' || 'Resolution Time'
          ? `dispute-case-tags-item--${item.status}`
          : item.value
          ? 'dispute-case-tags-item--highlight'
          : ''
      ">
      <span
        v-if="item.key === 'Case Aging'"
        class="dispute-case-tags-item__case-aging-block">
        <icon name="clock"></icon><span>{{ item.value }}</span>
      </span>
      <span
        v-else-if="item.key === 'Resolution Time'"
        class="dispute-case-tags-item__case-aging-block">
        <icon name="clock"></icon><span>{{ item.value }}</span>
      </span>
      <span
        v-else-if="item.key === 'Time Bar'"
        class="dispute-case-tags-item__case-aging-block">
        <icon name="clock"></icon><span>{{ item.value }}</span>
      </span>
      <span
        v-else-if="item.key === 'Contingency Reason'"
        class="dispute-case-tags-item__case-aging-block">
        <span>{{ item.value }}</span>
      </span>
      <span
        v-else
        :class="
          !item.value
            ? 'dispute-case-tags-item--strikethrough'
            : 'dispute-case-tags-item--normal'
        ">
        {{ item.key }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisputeCaseTags",
  props: {
    data: {
      type: Object,
      required: true,
    },
    isDetailsMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagData: [],
    };
  },
  watch: {
    data() {
      this.tagData = Object.values(this.data).filter(
        (item) => item.value !== null
      );
    },
  },
  mounted() {
    this.tagData = Object.values(this.data).filter(
      (item) => item.value !== null
    );
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";

.dispute-case-tags {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;

  &-item {
    background: var(--Gray-200);
    border-radius: 100px;
    margin-right: 0.5rem;
    padding: 0.25rem 1rem;
    margin-bottom: 1rem;

    &--highlight {
      background: var(--Blue-200);
    }

    &--strikethrough {
      text-decoration: line-through;
    }

    &--LOW,
    &--MEDIUM {
      background: #c5e5c2;
    }

    &--HIGH {
      background: #ffeba8;
    }

    &--CRITICAL {
      background: #e9b2b7;
    }

    &__case-aging-block {
      display: flex;

      i {
        margin-right: 4px;
      }

      span {
        margin-top: -1px;
      }
    }
  }
}
</style>
